"use client";

/**
 * Global error boundary — catches errors in the root layout itself.
 * Must render its own <html> and <body> since the layout may have crashed.
 * Never exposes internal error details to the user.
 */

export default function GlobalError({
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <html lang="en">
      <body
        style={{
          margin: 0,
          fontFamily:
            "system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
          display: "flex",
          minHeight: "100vh",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "#fafafa",
          color: "#1a1a1a",
        }}
      >
        <div style={{ textAlign: "center", maxWidth: 400, padding: 24 }}>
          <h2 style={{ fontSize: 18, fontWeight: 500, marginBottom: 8 }}>
            Something went wrong
          </h2>
          <p
            style={{
              fontSize: 14,
              color: "#666",
              marginBottom: 24,
              lineHeight: 1.5,
            }}
          >
            A critical error occurred. Please refresh the page or try again
            later.
          </p>
          <button
            onClick={reset}
            style={{
              padding: "10px 20px",
              fontSize: 14,
              fontWeight: 500,
              border: "none",
              borderRadius: 8,
              backgroundColor: "#2563eb",
              color: "#fff",
              cursor: "pointer",
            }}
          >
            Try again
          </button>
        </div>
      </body>
    </html>
  );
}
